const TOUR_KEY = 'mytownly_rider_tour_v2';

export const hasSeenTour = (uid) => {
  if (!uid) return true;
  try {
    return localStorage.getItem(`${TOUR_KEY}_${uid}`) === '1';
  } catch {
    return true;
  }
};

export const markTourSeen = (uid) => {
  if (!uid) return;
  try {
    localStorage.setItem(`${TOUR_KEY}_${uid}`, '1');
  } catch {
    /* private mode */
  }
};
